var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-card',{staticClass:"elevation-0 text-center",staticStyle:{"height":"100%"},attrs:{"max-height":"320px"}},[_c('strong',[_vm._v("Por Clientes")]),_c('Pie',{attrs:{"chart-options":_vm.chartOptions,"data":_vm.chartData}})],1),_c('h5',{staticClass:"pt-3"},[_vm._v("Ventas por tipo de cliente")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }